import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaintenanceListComponent } from './maintenance-list.component';
import { GlobalModulesModule } from '../../global-modules/global-modules.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule
  ],
  declarations: [MaintenanceListComponent],  
  exports: [MaintenanceListComponent],
})
export class MaintenanceListModule { }
